module.exports = __webpack_public_path__ + "img/Group 1421 (4).c0836269.png";